import { render } from "./TheDetailFrameModal.vue?vue&type=template&id=5ad18e4d"
import script from "./TheDetailFrameModal.vue?vue&type=script&lang=js"
export * from "./TheDetailFrameModal.vue?vue&type=script&lang=js"

import "./TheDetailFrameModal.vue?vue&type=style&index=0&id=5ad18e4d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__